import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseApi } from '../../base.api';
import { GiftCardAmount } from '../model/gift-card-amount';

@Injectable({ providedIn: 'root' })
export class GiftCardsApi extends BaseApi {
  getDefaultAmountsForGiftCards(): Observable<GiftCardAmount[]> {
    const url = this.baseUrl + '/public/online-gift-card/default-amounts';

    return this.httpClient.get<GiftCardAmount[]>(url);
  }
}
